export enum IdentificationTypes {
  CB_IDENTIFICACION_RUT = 'CB_IDENTIFICACION_RUT',
  CB_IDENTIFICACION_RUC = 'CB_IDENTIFICACION_RUC',
  CB_IDENTIFICACION_DNI = 'CB_IDENTIFICACION_DNI',
  CB_IDENTIFICACION_CPF = 'CB_IDENTIFICACION_CPF',
  CB_IDENTIFICACION_CNPJ = 'CB_IDENTIFICACION_CNPJ',
  CB_IDENTIFICACION_RFCPM = 'CB_IDENTIFICACION_RFCPM',
  CB_IDENTIFICACION_RFCPF = 'CB_IDENTIFICACION_RFCPF',
  CB_IDENTIFICACION_OTHER = 'CB_IDENTIFICACION_OTHER',
}
